import { select, put, call, takeLeading } from "redux-saga/effects";
import log from "loglevel";

import axios from "../../utils/axios";
import getEnvParam from "../../utils/getEnvParam";
import { Creators as actionsOrders } from '../ducks/orders'
import { requestDefaultJson } from './helpers'

import messages from '../../assets/i18n'

const orderFromApi = (options = {}) => {
	return new Promise((resolve, reject) => {
		return axios.request(options)
			.then(response => response.status !== 200 ? reject(response) : response)
			.then(response => response.data)
			.then(response => resolve(response))
			.catch(error => {
				reject(error);
				log.info(error);
			});
	});
};

const addFilter = (filter, filterName) => {
	if (filter) {
		return '&' + filterName + '=' + filter
	} else {
		return ''
	}
}

const formatOrderFilter = (ordenacao) => {
	if (ordenacao.includes('Asc')) {
		let filtersplit = ordenacao.split('Asc')

		return filtersplit[0] + '%20asc'
	} else {
		let filtersplit = ordenacao.split('Desc')

		return filtersplit[0] + '%20desc'
	}
}

const detailedReport = (payload, token) => {

    const {
        anoSemanaComercial,
        calendarioComercial,
        carga,
        cd,
		dataAgendamentoInicial,
        dataAgendamentoFinal,
        fornecedor,
		id,
		idEmpresa,
		naturezaPedido,
		ordenacao,
		status
    } = payload.filters

	const urlFilters =
		addFilter(anoSemanaComercial, 'anoSemanaComercial') +
		addFilter(calendarioComercial.semanaComercial, 'semanaComercial') +
		addFilter(carga, 'idCarga') +
		addFilter(cd, 'idLocalizacaoFisica') +
		addFilter(dataAgendamentoInicial, 'dataEntregaInicial') +
		addFilter(dataAgendamentoFinal, 'dataEntregaFinal') +
		addFilter(fornecedor.nome, 'fornecedor') +
		addFilter(id, 'id') +
		addFilter(idEmpresa, 'idEmpresa') +
		addFilter(naturezaPedido, 'naturezaPedido') +
		addFilter(status, 'status') +
		'&ordenacao=' + formatOrderFilter(ordenacao)

    return axios.request(getEnvParam("REACT_APP_BFF_URL_REST") + '/pedido/relatorio-detalhado?max=1000' + urlFilters, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "NPF_ROUTE": getEnvParam("REACT_APP_HEADER_PEDIDOS_REST"),
            Authorization: token,
        },
    }).then((response) => {
        return response;
    }).catch(error => {        
        log.info(error);
        return error
    });
};

const eventsLogFromApi = (payload, token) => {

    const {
        anoSemanaComercial,
        calendarioComercial,
        carga,
        cd,
        dataAgendamentoInicial,
        dataAgendamentoFinal,
        fornecedor,
        id,
        idEmpresa,
        naturezaPedido,
        ordenacao,
        status
    } = payload.filters

	const isNoFilterApplied = 
        !anoSemanaComercial &&
        !calendarioComercial.semanaComercial &&
        !carga &&
        !cd &&
        !dataAgendamentoInicial &&
        !dataAgendamentoFinal &&
        !fornecedor.nome &&
        !id &&
        !idEmpresa &&
        !naturezaPedido &&
        !status;

    let anoFiltro = anoSemanaComercial;
    if (isNoFilterApplied) {
        anoFiltro = new Date().getFullYear().toString(); 
    }

    const urlFilters =
        addFilter(anoFiltro, 'anoSemanaComercial') +
        addFilter(calendarioComercial.semanaComercial, 'semanaComercial') +
        addFilter(carga, 'idCarga') +
        addFilter(cd, 'idLocalizacaoFisica') +
        addFilter(dataAgendamentoInicial, 'dataEntregaInicial') +
        addFilter(dataAgendamentoFinal, 'dataEntregaFinal') +
        addFilter(fornecedor.nome, 'fornecedor') +
        addFilter(id, 'id') +
        addFilter(idEmpresa, 'idEmpresa') +
        addFilter(naturezaPedido, 'naturezaPedido') +
        addFilter(status, 'status') +
        '&ordenacao=' + formatOrderFilter(ordenacao)

	return axios.request(getEnvParam("REACT_APP_BFF_URL_REST") + '/pedido/eventos?max=1000' + urlFilters, {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
			"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_PEDIDOS_REST"),
			Authorization: token,
		},
    }).then((response) => {
        return response;
    }).catch(error => {        
        log.info(error);
        return error
    });
};

const getFiltroFormatado = (filters) => {
    return `{
		idEmpresa: "${filters.filters.idEmpresa ? filters.filters.idEmpresa : ""}",
		pedido: "${filters.filters.id ? filters.filters.id : ""}",
	    semanaComercial: ${filters.filters.calendarioComercial.semanaComercial ? filters.filters.calendarioComercial.semanaComercial : 0} ,
    	status: "${filters.filters.status ? filters.filters.status : ""}",
      	naturezaPedido: "${filters.filters.naturezaPedido ? filters.filters.naturezaPedido : ""}",
	  	fornecedor: "${filters.filters.fornecedor.nome ? filters.filters.fornecedor.nome : ""}",
	  	ordenacao: "${filters.filters.ordenacao ? filters.filters.ordenacao : ""}",
		cd: "${filters.filters.cd ? filters.filters.cd : ""}",
		anoSemanaComercial: "${filters.filters.anoSemanaComercial ? filters.filters.anoSemanaComercial : ""}",
		dataAgendamentoInicial: "${filters.filters.dataAgendamentoInicial ? filters.filters.dataAgendamentoInicial : ""}",
		dataAgendamentoFinal: "${filters.filters.dataAgendamentoFinal ? filters.filters.dataAgendamentoFinal : ""}",
		carga: "${filters.filters.carga ? filters.filters.carga : ""}",
    }`
}

function getOrdersFromApi(token, page = 1, filtro, size = 40) {

	return axios({
		method: "POST",
		headers: {
			"Content-Type": "application/graphql",
			"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_PEDIDOS"),
			"Authorization": token
		},
		data: `{
			listarPedidos(pagina:${page}, filtro:${getFiltroFormatado(filtro)}, max:${size}) {
				id
				prePo
				qtCompra
				dtEmissao
				status
				naturezaPedido
				amostraPedido
				sustentabilidade
				utilizaSubContratado
				amostraPedido
				origemPedido
				departamento
				departamentoId
				carga {
					id
					agendamentos {
						dtEntrega
						horaEntrega
					}
				}
				calendarioComercial {
					semanaComercial
					dataInicial
				}
				fornecedor {
					id
					nome
					exigirDeclProdutor
				}
				localizacaoFisica {
					id
					nome
				}
				empresa{
					id
					nome
					exigirDeclProdutor
					exigirCertSustentabilidade
				}
				conciliacaos {
                    id
                    statusConciliacaoComercial {
                        id
                        descricao
                    }
                    statusConciliacaoFiscal {
                        id
                        descricao
                    }
				}
			}
		}`
	}).then(result => {
		return result;
	}).then(

	).then();
}


function subcontractorFlag(payload, token) {
	const {
		idPedido,
		utilizaSubcontratado
	} = payload

	return axios({
		method: "POST",
		headers: {
			"Content-Type": "application/graphql",
			"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_PEDIDOS"),
			"Authorization": token
		},
		data: 
		`mutation {
			alterarUtilizaSubcontratado(idPedido: "${idPedido}", utilizaSubcontratado: ${utilizaSubcontratado})
		}`
	}).then(result => {
		return result;
	}).then(

	).then();
}

function realizarAceitePedido(payload, token) {
	const {
		idPedido,
	} = payload

	return axios({
		method: "POST",
		headers: {
			"Content-Type": "application/graphql",
			"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_PEDIDOS"),
			"Authorization": token
		},
		data: 
		`mutation {
			confirmarCienciaPedido(idPedido: "${idPedido}")
		}`
	}).then(result => {
		return result;
	}).then(

	).then();
}

function* orderById(payload, token) {
	try {
		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_PEDIDOS"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`{
				pedidoPorId(idPedido: "${payload.orderId}") {
					id
					prePo
					amostraPedido
					naturezaPedido
					naturezaPedidoId
					observacao
					origemPedido
					pais
					pgCond
					pgCondId
					pgDiasPrazo
					promocao
					promocaoChave
					promocaoId
					qtCompra
					qtPacotes
					qtPecas
					qtVolumes
					status
					sustentabilidade
					termosFrete
					tipoPedido
					tipoPedidoDescricao
					utilizaSubContratado
					versao
					departamento
					departamentoId
					dtCancelamento
					dtEmissao
					dtEntregaFim
					dtEntregaInicio
					dtPromocaoFim
					dtPromocaoInicio
					dtRecebimentoPo
					fastInd
					ffdd
					formaPg
					formaPgId
					cnpjComprador
					utilCode
					amostraStatus
 					amostraDtCancelamento
					origemStatus
					origemDtCancelamento
					localizacaoFisica {
						id
						bairro
						cep
						cnpj
						email
						endereco
						ie
						nome
						numero
						telefone
						tipoLocalidade
						uf
						cidade
					}
					calendarioComercial {
						id
						semanaComercial
						dataInicial
						dataFinal
					}
					carga {
						dtCriacao
						status
						agendamentos {
							id
							dtCriacao
							dtEntrega
							horaEntrega
							portao {
								id
								descricao
								nome
							}
						}
					}
					conciliacaos {
						id
						statusConciliacaoComercial {
							id
							descricao
						}
						statusConciliacaoFiscal {
							id
							descricao
						}
					}
					empresa {
						id
						nome
						exigirDeclProdutor
						exigirCertSustentabilidade
					}
					fornecedor {
						id
						cidade
						cnpj
						ediPoInd
						nome
						uf
						email
						exigirDeclProdutor
					}
					items {
						id
						aliquotaIcms
						aliquotaIpi
						cnpj
						codItem
						custoUnitario
						formaEnvio
						itemPai
						localizacaoFisica
						localizacaoFisicaTipo
						nivelItem
						nivelTransacional
						packInd
						pacote
						pacotePackInd
						packNo
						orderNo
						pais
						paisNome
						precoCusto
						qtCancelada
						qtCompra
						qtItens
						qtRecebida
						reducaoBaseIcms
						roundLvl
						skuCompra
						tamPacoteInner
						tamPacoteSupp
						unidadeVarejo
						valorBaseIcms
						qtVolume
						detalheItems {
							id
							cfaComposicao
							cfaDescricao
							cfaGrupoId
							char1
							classe
							classeId
							comentarios
							composicao
							departamento
							departamentoId
							descricaoCurta
							descricaoItem
							dtAprovacao
							dtRevisao
							ean
							fornecedorId
							grupoDiffId
							grupoMaterial
							grupoMaterialId
							grupoPadrao
							imagemDescricao
							imagemEndereco
							imagemNome
							ind4
							medida
							medidaId
							ncm
							pais
							paisFornecedorId
							paisOrigemId
							paisPrimarioInd
							remarkDesc
							sequencial1
							sequencial2
							statusMedida
							subClasse
							subClasseId
							tamExemploId
							tamPadraoId
							vpn
							caracteristicas {
								id
								caracteristica
								caracteristicaId
								caracteristicaTipo
								codIndustria
								codCountry
							}
							insumos {
								id
								codSeq
								codTipoId
								codType
								code
								codigoId
								indObrigatorio
								material
								materialId
								materialReferencia
								materialStatus
							}
							udas {
								id
								uda
								udaId
								udaValorId
								udaValue
								sustentabilidade
							}
						}
					}
				}
			}
			`
		};

		const { data } = yield call(orderFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

const redirectToLogin = (lang) => {
	alert(messages[lang].sessionExpired)
	window.location.href = getEnvParam('REACT_APP_URL_LOGIN') + 'logout';
}

//Generators
function* getOrdersAsync({page, filtro, size}) {
	
	const lang = yield select(state => state.language.name);

	try {
		const { token } = yield select(state => state.authentication);
		const { hasMore } = yield select(state => state.orders);
		let data;

		const actualPage = (!page) ?	0 : page;
		const nextPage = actualPage + 1;
		
		if (hasMore || actualPage <= 0) {
			if(actualPage <= 0) {
				yield put(actionsOrders.getOrdersAsyncLoading());
			} else {
				yield put(actionsOrders.getOrdersAsyncHasMoreLoading());
			}
			
			data = (yield call(getOrdersFromApi, token, nextPage, filtro, size)).data;
		}

		if (data && data.data) {
			const listOrders = data.data.listarPedidos;

			yield put({ 
				type: "GET_ORDERS_ASYNC", 
				payload: { 
					data: listOrders,
					page: nextPage,
					hasMore: listOrders.length > 0 ? true : false 
				}
			});
		} else {
			if(data && data.errors) {
				yield put({ type: "GET_ORDERS_ASYNC_ERROR", payload: data.errors[0] });
			}
		}

	} catch (error) {
		
		if (error.status === 401) {
			yield put({ type: 'LOGOUT_REQUEST' });
			redirectToLogin(lang);
		}

		yield put({ type: "GET_ORDERS_ASYNC_ERROR", payload: error });
		log.info(error);
	}
}

function* getDetailedReport({payload}) {
	try {

		yield put({ type: "SET_LOADING_DETAILED_REPORT", payload: true });

		const { token } = yield select(state => state.authentication);

		let response;
		response = yield call(detailedReport, payload, token);

		if (response && response.data) {
			yield put({ type: "SET_DETAILED_REPORT", payload: response.data });			
		}
		
		yield put({ type: "SET_LOADING_DETAILED_REPORT", payload: false });
	} catch (error) {	
		yield put({ type: "SET_LOADING_DETAILED_REPORT", payload: false });	
		log.info(error);
	}
}

function* getEventsLog({payload}) {
	try {

		const lang = yield select(state => state.language.name);

		yield put({ type: "SET_LOADING_EVENTS_LOG", payload: true });

		const { token } = yield select(state => state.authentication);

		let response = yield call(eventsLogFromApi, payload, token);

		if (response && response.data) {
			if(response.data.length > 0) {
				yield put({ type: "SET_EVENTS_LOG", payload: response.data });
			} else {
				yield put({
					type: "SET_EVENTS_LOG_TOAST",
					payload: {
						showToast: true,
						message: messages[lang].eventsLogEmpty,
						messageType: "toast-error"
					}
				})
			}
						
		}
		
		yield put({ type: "SET_LOADING_EVENTS_LOG", payload: false });
	} catch (error) {	
		yield put({ type: "SET_LOADING_EVENTS_LOG", payload: false });	
		log.info(error);
	}
}

//Generators
function* getOrdersAsyncDownload({filtro, size}) {
	
	try {
		const { token } = yield select(state => state.authentication);
		let data;

		const actualPage = 0;
		let nextPage = actualPage + 1;
		
		yield put(actionsOrders.getOrdersAsyncLoadingDownload());

		data = (yield call(getOrdersFromApi, token, nextPage, filtro, size)).data;

		if (data && data.data) {
		
			let listOrders = data.data.listarPedidos;
			
			while(data.data.listarPedidos.length > 0) {

				nextPage = nextPage + 1;

				data = (yield call(getOrdersFromApi, token, nextPage, filtro, size)).data;
				listOrders.push(...data.data.listarPedidos);
			}

			yield put({ 
				type: "GET_ORDERS_ASYNC_DOWNLOAD", 
				payload: { 
					data: listOrders,
				}
			});
		}
	} catch (error) {		
		log.info(error);
	}
}

function* updateOrderSubcontractor(payload) {
	try {
		const { token } = yield select(state => state.authentication);

        yield put({ type: "SET_ORDER_LOADING", payload: true});

		const returnData = yield call(subcontractorFlag, payload.payload, token);

        yield put({ type: "SET_ORDER_LOADING", payload: false});

		if (returnData.data && returnData.data.data && returnData.data.data.alterarUtilizaSubcontratado) {
			let validation = returnData.data.data.alterarUtilizaSubcontratado

			if (validation === 'OK!' && payload.payload.utilizaSubcontratado) {
				yield put({ type: "REDIRECT_TO_SUBCONTRACTOR_INVOICE_DETAILS", payload: true});
			}
		}
	} catch (error) {
		log.info(error);
	}
}


function* getOrderById({payload}) {
	try {
		yield put({ type: "SET_ORDER_BY_ID", payload: {error: false}});
		yield put({ type: "SET_ORDER_BY_ID_LOADING", payload: true});

		const { token } = yield select(state => state.authentication);
		
		const result = yield call(orderById, payload, token);

		if (result && result.pedidoPorId) {
            yield put({ type: "SET_ORDER_BY_ID", payload: { ...result.pedidoPorId, error: false}});
        } else {
			yield put({ type: "SET_ORDER_BY_ID", payload: {error: true}});
		}
	} catch (error) {
		yield put({ type: "SET_ORDER_BY_ID", payload: {error: true}});
		log.info(error);
	} finally {
		yield put({ type: "SET_ORDER_BY_ID_LOADING", payload: false});
	}
}

function* aceitarPedido(payload) {
	try {
		const { token } = yield select(state => state.authentication);
		const lang = yield select(state => state.language.name);

        yield put({ type: "SET_ORDER_LOADING", payload: true});

		const returnData = yield call(realizarAceitePedido, payload.payload, token);

        yield put({ type: "SET_ORDER_LOADING", payload: false});

		if (returnData && returnData.data && returnData.data.data) {
			if (returnData.data.data.confirmarCienciaPedido && returnData.data.data.confirmarCienciaPedido === 'OK') {
				yield put({ 
					type: "SET_NEW_ORDER_TOAST", 
					payload: {
						showToast: true,
						message: messages[lang].orderOptionsPage.pedidoAceito,
						messageType: "toast-success"
				}});
			}
		}
	} catch (error) {
		log.info(error);
	} finally {
		yield put({ type: "SET_ORDER_BY_ID_LOADING", payload: false});
	}
}

function* getRestoSobra({payload}) {
	try {
		yield put({ type: "SET_RESTO_SOBRA", payload: {}});
		yield put({ type: "SET_RESTO_SOBRA_LOADING", payload: true});

		const { token } = yield select(state => state.authentication);
		
		const result = yield call(getRestosSobraFromAPi, payload.orderId, token);

		if (result) {
            yield put({ type: "SET_RESTO_SOBRA", payload: { ...result}});
        }
	} catch (error) {
		yield put({ type: "SET_RESTO_SOBRA_TOAST", payload: {showToast: true, messageType:"toast-error", message: error?.response?.data?.message}});
	} finally {
		yield put({ type: "SET_RESTO_SOBRA_LOADING", payload: false});
	}
}

const getRestosSobraFromAPi = (id, token) => {
	return requestDefaultJson({
		URIComplete: getEnvParam("REACT_APP_BFF_URL_REST") + "/restos-sobras/itens/" + id,
		method: "GET", 
		headers: {
			"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_RESTO_SOBRA"),
			"Authorization": token
		},
	});
};

function* saveRestoSobra({payload}) {
	try {
		yield put({ type: "SET_RESTO_SOBRA_LOADING_SAVE", payload: true});
		const { token } = yield select(state => state.authentication);
		yield call(saveRestosSobraFromAPi, payload, token);
	} catch (error) {
		if (error.status !== 201) {
			yield put({ type: "SET_RESTO_SOBRA_TOAST", payload: {showToast: true, messageType:"toast-error", message: error?.response?.data?.message}});
		} else {
			yield put({ type: "SET_RESTO_SOBRA_TOAST", payload: {showToast: true, messageType:"toast-success", message: ""}});
		}
	} finally {
		yield put({ type: "SET_RESTO_SOBRA_LOADING_SAVE", payload: false});
	}
}

const saveRestosSobraFromAPi = ({restoSobra}, token) => {
	return requestDefaultJson({
		URIComplete: getEnvParam("REACT_APP_BFF_URL_REST") + "/restos-sobras",
		method: "POST", 
		headers: {
			"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_RESTO_SOBRA"),
			"Authorization": token
		},
		data: restoSobra,
	});
};

//Generator function
export function* getOrdersWatcher() {
	yield takeLeading("GET_ORDERS", getOrdersAsync);
	yield takeLeading("GET_ORDERS_DOWNLOAD", getOrdersAsyncDownload);
	yield takeLeading("UPDATE_ORDER_SUBCONTRACTOR", updateOrderSubcontractor);
	yield takeLeading("GET_ORDER_BY_ID", getOrderById);
	yield takeLeading("ACEITAR_PEDIDO", aceitarPedido);
	yield takeLeading("GET_DETAILED_REPORT", getDetailedReport);
	yield takeLeading("GET_RESTO_SOBRA", getRestoSobra);
	yield takeLeading("SAVE_RESTO_SOBRA", saveRestoSobra);
	yield takeLeading("GET_EVENTS_LOG", getEventsLog);
}
